module.exports = __webpack_public_path__ + "images/checkmark-af35f846.svg";